import { Component, OnDestroy, OnInit } from '@angular/core';
import { ITerms } from 'src/app/@shared/model/terms.model';
import { DomSanitizer } from '@angular/platform-browser';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import {IMeta, MetaService} from "@shared/services/web/meta.service";
import {BreadcrumbsService} from "@shared/services/web/breadcrumbs.service";
import {TermsService} from "@shared/services/api/terms.service";
@Component({
  selector: 'app-terms',
  templateUrl: './terms.component.html',
  styleUrls: ['./terms.component.scss'],
})
export class TermsComponent implements OnInit, OnDestroy {
  private changeLangSubscription: Subscription;
  lang: string;
  terms: ITerms;
  isLoading: boolean = false;

  constructor(
    public termsService: TermsService,
    private sanitizer: DomSanitizer,
    private translateService: TranslateService,
    private metaService: MetaService,
    private breadcrumbsService: BreadcrumbsService
  ) {
    this.changeMeta();
    this.setBreadcrumb();
  }

  changeMeta() {
    const meta: IMeta = {
      language: this.translateService.currentLang,
      title: 'terminos',
      description: 'terminos_desc',
    };
    this.metaService.changeMeta(meta);
  }

  ngOnInit() {
    this.lang = this.translateService.currentLang;
    this.isLoading = true;
    this.termsService.getTerms().subscribe((data) => {
      this.terms = data;
      this.isLoading = false;
    });

    this.changeLangSubscription = this.translateService.onLangChange.subscribe(
      (event: LangChangeEvent) => {
        this.lang = event.lang;
        this.changeMeta();
      }
    );
  }

  ngOnDestroy() {
    if (this.changeLangSubscription) {
      this.changeLangSubscription.unsubscribe();
    }
  }

  transform(terms: ITerms): any {
    if (this.lang == 'es') {
      return this.sanitizer.bypassSecurityTrustHtml(terms.text);
    } else if (this.lang == 'en') {
      return this.sanitizer.bypassSecurityTrustHtml(terms.text_en);
    }
  }
  setBreadcrumb() {
    this.breadcrumbsService.setBreadcrumb([
      { label: 'Inicio', label_en: 'Home', path: '/' },
      {
        label: 'Términos y condiciones',
        label_en: 'Terms and conditions',
        path: null,
      },
    ]);
  }
}
